module.exports = __webpack_public_path__ + "img/39.ada37f8e.png";